(function () {
	function ChoicesSelect(root, config) {
		this.root = root;
		this.options = (config && config.options) || [];
		this.placeholder = (config && config.placeholder) || '';
		this.value = (config && config.value) || '';
		this.onChange = (config && config.onChange) || null;

		// Build DOM
		var trigger = document.createElement('button');
		trigger.type = 'button';
		trigger.className = 'w-full border border-white px-2 py-1 text-sm flex items-center justify-between rounded-sm md:text-[1.2rem] md:leading-[2rem]';
		trigger.setAttribute('aria-haspopup', 'listbox');
		trigger.setAttribute('aria-expanded', 'false');

		var labelSpan = document.createElement('span');
		var renderLabel = function (target, text) {
			if (!target) return;
			target.innerHTML = '';
			var rawText = String(text == null ? '' : text);
			var soldOutMatch = rawText.match(/^(.*?)(\s*\(SOLD OUT\))$/i);
			if (soldOutMatch) {
				target.appendChild(document.createTextNode(soldOutMatch[1]));
				var soldOutSpan = document.createElement('span');
				soldOutSpan.className = 'text-[0.7em] leading-none align-baseline';
				soldOutSpan.textContent = soldOutMatch[2];
				target.appendChild(soldOutSpan);
				return;
			}
			target.textContent = rawText;
		};
		renderLabel(labelSpan, this._labelFor(this.value) || this.placeholder || '');
		var caretSpan = document.createElement('span');
		caretSpan.className = 'text-xs';
		caretSpan.style.display = 'inline-block';
		caretSpan.style.transition = 'transform 150ms ease';
		caretSpan.style.transform = 'rotate(0deg)';
		caretSpan.setAttribute('aria-hidden', 'true');

		// 90-degree chevron (right angle) via inline SVG
		var caretSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		caretSvg.setAttribute('viewBox', '0 0 16 16');
		caretSvg.setAttribute('width', '10');
		caretSvg.setAttribute('height', '10');
		caretSvg.style.display = 'block';
		caretSvg.style.color = 'currentColor';
		var caretPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		// Points: (2,5) -> (8,11) -> (14,5). Angle at (8,11) is 90 degrees.
		caretPath.setAttribute('d', 'M2 5 L8 11 L14 5');
		caretPath.setAttribute('fill', 'none');
		caretPath.setAttribute('stroke', 'currentColor');
		caretPath.setAttribute('stroke-width', '1.6');
		caretPath.setAttribute('stroke-linecap', 'square');
		caretPath.setAttribute('stroke-linejoin', 'miter');
		caretSvg.appendChild(caretPath);
		caretSpan.appendChild(caretSvg);
		trigger.appendChild(labelSpan);
		trigger.appendChild(caretSpan);

		var list = document.createElement('ul');
		list.className = 'overflow-auto bg-white text-black text-sm hidden absolute w-full z-10 shadow-sm shadow-black/25 mt-0.5 rounded-b-sm';
		list.setAttribute('role', 'listbox');

		var renderOptions = function () {
			list.innerHTML = '';
			this.options.forEach(function (opt) {
				var li = document.createElement('li');
				li.className = 'px-3 py-2 hover:bg-gray-100 hover:text-black cursor-pointer';
				li.setAttribute('role', 'option');
				li.dataset.value = opt.value;
				renderLabel(li, opt.label);
				if (opt.value === this.value) {
					li.classList.add('bg-white', 'text-black');
				}
				list.appendChild(li);
			}.bind(this));
		}.bind(this);

		// Mount
		root.innerHTML = '';
		root.appendChild(trigger);
		root.appendChild(list);
		renderOptions();

		// Events
		var open = false;
		var toggle = function (nextOpen) {
			open = (typeof nextOpen === 'boolean') ? nextOpen : !open;
			list.classList.toggle('hidden', !open);
			trigger.setAttribute('aria-expanded', String(open));
			// rotate caret when open
			caretSpan.style.transform = open ? 'rotate(180deg)' : 'rotate(0deg)';
		};

		trigger.addEventListener('click', function () { toggle(); });
		document.addEventListener('click', function (e) {
			if (!root.contains(e.target)) toggle(false);
		});
		list.addEventListener('click', function (e) {
			var li = e.target.closest('li[role="option"]');
			if (!li) return;
			var newVal = li.dataset.value || '';
			this.setValue(newVal);
			toggle(false);
		}.bind(this));

		// API
		this.getValue = function () { return this.value; };
		this.setValue = function (val) {
			this.value = val;
			// Update label
			renderLabel(labelSpan, this._labelFor(this.value) || this.placeholder || '');
			// Update active state
			list.querySelectorAll('li').forEach(function (li) {
				li.classList.remove('bg-white', 'text-black');
				if (li.dataset.value === val) {
					li.classList.add('bg-white', 'text-black');
				}
			});
			if (typeof this.onChange === 'function') this.onChange(this.value);
		}.bind(this);
		this.setOptions = function (options, nextValue) {
			this.options = options || [];
			if (typeof nextValue !== 'undefined') {
				this.value = nextValue;
			}
			renderLabel(labelSpan, this._labelFor(this.value) || this.placeholder || '');
			renderOptions();
		}.bind(this);
	}

	ChoicesSelect.prototype._labelFor = function (val) {
		var match = this.options.find(function (o) { return o.value === val; });
		return match ? match.label : null;
	};

	// Expose globally
	window.ChoicesSelect = ChoicesSelect;
})();
